import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import user from "./user.js";
import general from "./general.js";
import snackbar from "./snackbar.js";
import nav from "./navSetup.js";

const state = {};

const mutations = {};

const getters = {};

const actions = {};

export default new Vuex.Store({
  modules: {
    user,
    general,
    snackbar,
    nav,
  },
  //   namespaced: true,
  state,
  mutations,
  getters,
  actions,
  //   namespaced,
});
